import React from "react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import {Button, ButtonGroup} from "semantic-ui-react";

export default class SourceDetailInfo extends React.Component {

    static propTypes = {
        sourceDetail: PropTypes.object,
    }

    render() {

        const {sourceDetail} = this.props;

        return(
            <div>
                <ButtonGroup>
                    <Button
                        content="Overview"
                    />
                </ButtonGroup>
                <div className="detail-info">
                    <div>
                        <span>{"Description:"}</span>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sourceDetail.source_detail.source_type_description) }} />
                    </div>
                    <div>
                        <span>{"Details:"}</span>
                        {sourceDetail.source_detail.overall_coverage
                            ? (
                                <p>
                                    {"Coverage: "}{sourceDetail.source_detail.overall_coverage + " "}
                                    {sourceDetail.source_detail.coverage_type}
                                </p>
                            )
                            : (<p>{"Coverage: "}</p>)}

                        <p>
                            {"Refresh Frequency: "}{sourceDetail.source_detail.data_refresh_frequency === ""
                            ? ""
                            : sourceDetail.source_detail.data_refresh_frequency}
                        </p>
                    </div>
                    <div>
                        <span>{"Access Requirements: "}</span>
                        <p>
                            {"Consent Required: "}{sourceDetail.source_detail.consent_required ? "YES" : "NO"}
                        </p>
                        {sourceDetail.source_detail.contractual_passthrough
                            ? (
                                <div>
                                    <p><b>{"Contractual Passthrough Sample: "}</b></p>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sourceDetail.source_detail.passthrough_sample) }} />
                                </div>
                            )
                            : null
                        }
                        {sourceDetail.source_detail.consent_flag_required
                            ? (
                                <div>
                                    <p><b>{"Consent Flag Sample: "}</b></p>
                                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sourceDetail.source_detail.flag_required_sample) }} />
                                </div>
                            )
                            : null
                        }

                    </div>
                    <div className={"notes-container"}>
                        <h4>Notes:</h4>
                        {sourceDetail.notes
                            ?  sourceDetail.notes.map((note, idx) => {
                                const labelText = note.type === "External"
                                    ? "Notes For The Customer."
                                    : "Internal GDC Notes."
                                return (
                                    <div key={idx}>
                                        <h4>{labelText}</h4>
                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.note) }} />
                                    </div>
                                )
                            }) : (
                                <div>
                                    <p>
                                        Not Available.
                                        Please Add Notes.
                                    </p>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}
